import { gql } from '@apollo/client';
export const UPSERT_AVAILABILITY = gql `
  mutation canUpsertAvailability($id: Int, $from: timestamptz!, $to: timestamptz!, $availability_status: String!) {
    can_upsert_availability(id: $id, from: $from, to: $to, availability_status: $availability_status) {
      id
      updated_at
    }
  }
`;
